import React from 'react'
import DiffViewer from 'react-diff-viewer'
import { Space, Typography } from 'antd'
import MarkdownRenderer from '../../../../../../../components/common/markdown-renderer/MarkdownRenderer'
import AiIcon from '../../../../../../../components/common/icons/AiIcon'

const { Text } = Typography

/**
 * Reusable DiffViewer component for showing text differences
 */
const TextDiffViewer = ({ oldValue, newValue, showDiff = true }) => {
    if (showDiff) {
        return (
            <DiffViewer
                oldValue={oldValue}
                newValue={newValue}
                splitView={true}
                showDiffOnly={false}
                compareMethod='diffCss'
                hideLineNumbers={true}
                styles={{
                    line: {
                        borderRadius: '16px',
                        overflow: 'hidden',
                    },
                    wordRemoved: {
                        borderRadius: '4px',
                    },
                    wordAdded: {
                        borderRadius: '4px',
                    },
                    marker: {
                        display: 'none',
                    },
                }}
            />
        )
    }

    return (
        <Space direction='vertical'>
            <MarkdownRenderer content={newValue} />
        </Space>
    )
}

export default TextDiffViewer
